export enum AIMessageAuthorType {
  Assistant = 'assistant',
  User = 'user'
}


export enum AIMessageType {
  User = 'user', // messages sent by user
  AI = 'ai', // messages sent by AI
  System = 'system', // system messages, e.g., errors, notifications
  Message = 'message', // generic message type, can be used for both user and AI messages
  FunctionCall = 'function_call', // messages related to function calls
  Planning = 'planning', // messages related to planning
}


//  'public-channel' | 'private-channel' | 'direct-message';
export enum ProjectChannelType {
  PublicChannel = 'public-channel',
  PrivateChannel = 'private-channel',
  DirectMessage = 'direct-message'
}
